"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextButton = void 0;
const phaser_1 = __importDefault(require("phaser"));
const RoundedButton_1 = require("./RoundedButton");
const Utils_1 = require("../utils/Utils");
const ColorPalette_1 = require("../constants/ColorPalette");
class TextButton extends RoundedButton_1.RoundedButton {
    /**
     * Create a button like a rounded button included text, icon in the center.
     * @param scene Scene
     * @param options rounded button options: x, y, width, height, color,...
     * @param text Text object
     * @param icon Icon image object
     */
    constructor(scene, options, text, icon) {
        super(scene, options);
        this.text = text;
        this.initialTextColor = this.text.style.color;
        const scale = Utils_1.Utils.scale;
        const child = new phaser_1.default.GameObjects.Container(scene);
        if (!icon) {
            text.setOrigin(0.5);
            child.add(text);
            this.add(child);
            return;
        }
        icon.setOrigin(0);
        text
            .setOrigin(0, 0.5)
            .setPosition(icon.displayWidth + 10 * scale, icon.displayHeight / 2);
        child.add([icon, text]);
        child.setSize(icon.displayWidth + 10 * scale + text.displayWidth, icon.displayHeight);
        child.setPosition(-child.displayWidth / 2, -child.height / 2);
        this.add(child);
    }
    /**
     * Overriding method
     * Set enable/disable for the button
     * @param enabled boolean
     */
    setEnabled(enabled) {
        var _a;
        super.setEnabled(enabled);
        (_a = this.text) === null || _a === void 0 ? void 0 : _a.setColor(enabled ? this.initialTextColor : ColorPalette_1.ColorPalette.GreyDisabledText);
    }
}
exports.TextButton = TextButton;
